import { SLUG_MAX_LENGTH } from '../constants';

const GERMAN_TRANSLITERATION: Readonly<Record<string, string>> = {
  ä: 'ae',
  ö: 'oe',
  ü: 'ue',
  Ä: 'ae',
  Ö: 'oe',
  Ü: 'ue',
  ß: 'ss',
  ẞ: 'ss',
};

/**
 * URL/file-name safe slug with German transliteration:
 * `Müller & Söhne GmbH` → `mueller-soehne-gmbh`, `Willkommenspaket Oktober 2026` → `willkommenspaket-oktober-2026`.
 * Other diacritics are stripped (`Café` → `cafe`). Result contains only `[a-z0-9-]`.
 */
export function slugify(input: string, maxLength: number = SLUG_MAX_LENGTH): string {
  const slug = input
    .replace(/[äöüÄÖÜßẞ]/gu, (char) => GERMAN_TRANSLITERATION[char] ?? char)
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/gu, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/gu, '-')
    .replace(/^-+|-+$/gu, '');
  return slug.slice(0, maxLength).replace(/-+$/u, '');
}
